import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PhotosPage from './PhotosPage';
import { User, UserService } from '../user';
import RemoteDataContent from '../common/ui-component/layouts/RemoteDataContent';
import { LOGIN_ROUTE } from '../Router';
import reactPress from '../reactpress';
import PhotoService from './PhotoService';
import { RemoteFile } from '../files';
import { isNotAsked, isSuccess } from '../utils/remote-data';

const AuthenticatedPhotosPageProvider = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [getCurrentUser, rCurrentUser] = UserService.useGetCurrentUser();
  const [getPhotos, rPhotos] = PhotoService.useGetPhotos();

  useEffect(() => {
    getCurrentUser(reactPress.user.ID);
  }, [getCurrentUser, searchParams]);

  useEffect(() => {
    if (isSuccess(rCurrentUser) && rCurrentUser.value && isNotAsked(rPhotos)) {
      const user = rCurrentUser.value as User;
      getPhotos(user.id);
    }
  }, [getPhotos, rCurrentUser, rPhotos]);

  return (
    <RemoteDataContent value={rCurrentUser}>
      <RemoteDataContent.Success>
        {(user: User) => {
          return (
            <RemoteDataContent value={rPhotos}>
              <RemoteDataContent.Success>
                {(photos: RemoteFile[]) => {
                  return <PhotosPage user={user} existingPhotos={photos} refetchPhotos={getPhotos} />;
                }}
              </RemoteDataContent.Success>
            </RemoteDataContent>
          );
        }}
      </RemoteDataContent.Success>
      <RemoteDataContent.Failure>
        {() => {
          window.location.href = LOGIN_ROUTE;
          return (
            <div className="tw-flex tw-w-full tw-justify-center">
              <span>{t('redirect')}</span>
            </div>
          );
        }}
      </RemoteDataContent.Failure>
    </RemoteDataContent>
  );
};

export default AuthenticatedPhotosPageProvider;
